export var ACTIVATION_CTA = 'Act10';
export var ACTIVATION_FORM = 'Act20';
export var ACTIVATION_SUCCESS = 'Act30';
export var ACTIVATION_NO_SUBSCRIPTION = 'Act31';
export var ACTIVATION_NO_ACCESS = 'Act32';
export var ACTIVATION_HAS_ACCESS = 'Act33';
export var ACTIVATION_ERROR = 'Act34';
export var MULTIBRAND_ACTIVATION = 'MultiBrandActivation';
export var MULTIBRAND_SUCCESS = 'MultiBrandSuccess';